import client, { PRIVATE_CLIENT } from '../../services/client';
import { get } from 'svelte/store';
import authStore from '../../store/auth';
import sessionStore from '../../store/session';
import { generateOauthUrl as ZohoGenerateOauthUrl, getOauthStatus as ZohoGetOauthStatus } from '../provider/zoho.action';
const BASE_URL = 'https://telephony.api.pressone.co/api/v1/';
export const getBusiness = async (business_id) => {
    return await client.get(`business/${business_id}/`, PRIVATE_CLIENT);
};
export const getBusinesses = async () => {
    const { personal_email, id, first_name, last_name, profiles = [] } = await client.get('user/me/', PRIVATE_CLIENT);
    const user = { personal_email, id, first_name, last_name };
    return { user, profiles };
};
export const getNumbers = async (business_id) => {
    const { user } = get(authStore);
    return await client.get(`business/${business_id}/user/${user.id}/`, PRIVATE_CLIENT, {});
};
export const getTeamMembers = async (business_id, page = 1) => {
    return await client.get(`business/${business_id}/user/`, PRIVATE_CLIENT, {
        page_size: page
    });
};
export const getOauthStatus = async () => {
    const type = process.env.APP_PROJECT_TYPE;
    let connected = true;
    if (!type) {
        return !connected;
    }
    switch (type) {
        case 'zoho':
            connected = await ZohoGetOauthStatus();
            break;
        default:
            break;
    }
    sessionStore.setAppConnection(connected);
    return connected;
};
export const generateOauthUrl = async () => {
    const type = process.env.APP_PROJECT_TYPE;
    let oauthUrl = '';
    switch (type) {
        case 'zoho':
            oauthUrl = await ZohoGenerateOauthUrl();
            break;
        default:
            break;
    }
    return oauthUrl;
};
